import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { CardContainer } from '../../../../components/card-container'
import SvgIcon from '../../../common/common/svgicon/svgicon'
import IntlUtil from '../../../lib/intlutil'
import { StyledLink, SubTitle, Title } from './styled'

/**
 * Globally removes hyphens from the given string
 * @param {string} str
 */
const stripDashes = str => str.replace(/-/g, '')

/**
 * @param {string} reportId
 * @returns {JSX.Element}
 */
const ReportItem = ({ reportId }) => {
  const [title, setTitle] = useState()
  const [subTitle, setSubTitle] = useState()
  const [href, setHref] = useState()

  useEffect(() => {
    const translationPostfix = stripDashes(reportId).toLowerCase()

    setTitle(IntlUtil.convertMessage(`report.item.title${translationPostfix}`))
    setSubTitle(IntlUtil.convertMessage(`report.item.content${translationPostfix}`))
    setHref(`report-view/${reportId}`)
  }, [reportId])

  return (
    <CardContainer>
      <StyledLink title={title} href={href}>
        <SvgIcon name={`reports--${reportId}`} className='icon' size='70' />
        <Title>{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
      </StyledLink>
    </CardContainer>
  )
}

ReportItem.propTypes = {
  reportId: PropTypes.string.isRequired
}

export { ReportItem }
